import React from 'react';
import { useDeviceTilt, LEVEL_THRESHOLD_DEG } from 'hooks/useDeviceTilt';
import styles from './TiltIndicator.module.scss';

// Degrees of pitch that map to the ends of the gauge.
const TRAVEL_DEG = 30;
// How far (% of track) the marker travels from centre to each end.
const MAX_OFFSET_PCT = 42;

const clampFrac = (v: number) => Math.max(-1, Math.min(1, v / TRAVEL_DEG));

const TiltIndicator = () => {
    const { supported, permission, requestPermission, pitch, isLevel } = useDeviceTilt();

    if (!supported) return null;

    if (permission === 'unknown') {
        return (
            <button type="button" className={styles.enableBtn} onClick={requestPermission}>
                Enable level guide
            </button>
        );
    }

    if (permission !== 'granted') return null;

    // Marker position on the vertical track; centre = upright.
    const markerTop = 50 + clampFrac(pitch) * MAX_OFFSET_PCT;
    // Visual size of the "in tolerance" band, matched to the real threshold.
    const bandHalf = (LEVEL_THRESHOLD_DEG / TRAVEL_DEG) * MAX_OFFSET_PCT;

    const hint = isLevel
        ? 'Upright'
        : pitch > 0
            ? 'Tilt forward'   // leaning back too far
            : 'Tilt back';     // leaning forward too far

    return (
        <div className={`${styles.gauge} ${isLevel ? styles.ok : ''}`}>
            <div className={styles.track}>
                <span
                    className={styles.band}
                    style={{ top: `${50 - bandHalf}%`, height: `${bandHalf * 2}%` }}
                />
                <span className={styles.centerLine} />
                <span className={styles.marker} style={{ top: `${markerTop}%` }} />
            </div>
            <span className={styles.label}>{hint}</span>
        </div>
    );
};

export default TiltIndicator;
